import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons';

import { Section } from '../../models/Section';
import { getSectionVideo } from '../../models/sectionVideos';
import { SectionVideoModal } from './section-video-modal';

type Props = {
  section: Section;
};

// Play icon that sits beside a section's panel title and opens that section's
// practitioner explainer video. Drop it into any Card.Header; it renders nothing
// for sections with no video, so headers stay untouched until a clip is recorded.
// Its own leading margin lives here rather than in the headers, so a section
// without a video doesn't carry stray trailing space after its title.
//
// Free-solid (not pro-solid) deliberately: on Results Overview this sits right
// next to the free-solid info-circle, and matching sets keeps the pair evenly
// weighted.
export const SectionVideoIcon = ({ section }: Props) => {
  const video = getSectionVideo(section);
  const [show, setShow] = React.useState(false);

  if (!video) {
    return null;
  }

  return (
    <>
      {/* stopPropagation is mandatory — every Card.Header hosting this icon has
          its own onClick that collapses the section. Same guard the neighbouring
          info-circle icons use. The modal itself portals to document.body, so
          clicks inside it never bubble back here. */}
      <span onClick={e => e.stopPropagation()} style={{ marginLeft: 10 }}>
        <FontAwesomeIcon
          icon={faPlayCircle}
          style={{ color: '#fff', cursor: 'pointer' }}
          title={`Watch: ${video.title}`}
          onClick={() => setShow(true)}
        />
      </span>
      <SectionVideoModal
        show={show}
        onHide={() => setShow(false)}
        src={video.src}
        title={video.title}
      />
    </>
  );
};
